<template>
  <div class="graphql">
  </div>
</template>

<script>
import utils from '@/services/utils';
import api from '@/api/graphql/demo/graphql';
import { query, mutation } from '@/services/graphql';

export default {
  name: 'graphql',
  data() {
    return {};
  },
  mounted() {
    api
      .fetch()
      .then((data) => {
        utils.log(data);
      });
    api
      .get({ id: 1 })
      .then((data) => {
        utils.log(data);
      });
    api
      .multi({ id: 1 })
      .then((data) => {
        utils.log(data);
      });
    api
      .update({ id: 1, name: 'Quiz 1' })
      .then((data) => {
        utils.log(data);
      });
    mutation(`
      mutation($account: String, $password: String) {
        login(account: $account, password: $password) {
          token
          tokenExpireTime
          account {
            id
            account
            name
          }
        }
      }
    `, {
      account: 'CS0001',
      password: 'D9E0BB',
    }).then((data) => {
      utils.log(data);
      utils.login(data.login);
    }).then(() => {
      query(`
        query {
          account {
            id
            name
          }
        }
      `).then(({ account }) => {
        utils.log(account);
      });
    });
  },
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';

</style>
